import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
.use(LanguageDetector) // Detect user language
  .use(Backend) // Load translations using http (default: .json files)
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  
  .init({
    supportedLngs: ['en', 'id', 'tgl'], // Supported languages
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    fallbackLng: 'en', // Fallback language if translation is missing
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
    },
    ns: ['translation'], // Namespace(s) used
    defaultNS: 'translation', // Default namespace
    interpolation: {
      escapeValue: false, // React already escapes output
    },
  });

export default i18n;
